import { OrgUnit } from '../../types/orgUnit';

/**
 * V73: 지정 조직 + 모든 하위조직 ID 반환 (BFS)
 *
 * BE getSubtreeOrgUnitIds (orgManagementScope.ts:178) 와 동일 로직.
 * 조직 필터에서 상위조직 선택 시 하위조직 인원 포함 조회에 사용.
 */
export function getDescendantOrgUnitIds(
  orgUnitId: string,
  orgUnits: OrgUnit[]
): string[] {
  const childrenMap = new Map<string, string[]>();
  for (const ou of orgUnits) {
    if (ou.status !== 'active') continue;
    const pid = ou.parentId ?? '__root__';
    if (!childrenMap.has(pid)) childrenMap.set(pid, []);
    childrenMap.get(pid)!.push(ou.id);
  }

  const result: string[] = [orgUnitId];
  const queue = [orgUnitId];
  while (queue.length > 0) {
    const current = queue.shift()!;
    const children = childrenMap.get(current) || [];
    for (const child of children) {
      result.push(child);
      queue.push(child);
    }
  }
  return result;
}
